import { fetchReactionListApi } from 'api/messengerReactions/fetchReactionListApi'

export const FETCH_REACTION_LIST = 'FETCH_REACTION_LIST' as const

export const fetchReactionListAction = () => ({
  type: FETCH_REACTION_LIST,
  promise: fetchReactionListApi,
})
